module.exports = __webpack_public_path__ + "static/slidecard02_02-bc71e7fa6622999abea7a10cde976bb4.png";